import { Nominee } from '../types/nominee';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const NomineeApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getNominees: build.query<any, void>({
      query: () => ({
        url: appEndpoint.nominees,
        method: 'get',
      }),
      providesTags: ['awardDetail'],
    }),
    addNominee: build.mutation<any, CommandRequest<Nominee>>({
      query: (data) => ({
        url: appEndpoint.nominees,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["awardDetail"] : []),
    }),
    updateNominee: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.nominees}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["awardDetail"] : []),
    }),
    changeNomineeStatus: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.nominees}/${data.id}/status`,
        method: 'patch',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["awardDetail"] : []),
    }),

    getNomineeById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.nominees}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'awardDetail', id }],
    }),
    deleteNominee: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.nominees}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['awardDetail'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNomineesQuery,
  useGetNomineeByIdQuery,
  useDeleteNomineeMutation,
  useUpdateNomineeMutation,
  useAddNomineeMutation,
  useChangeNomineeStatusMutation,
} = NomineeApi; 